import { useEffect, useState } from "react";

const links = [
  { label: "头版大瓜", href: "#headline" },
  { label: "吃瓜瓜棚", href: "#columns" },
  { label: "实时热榜", href: "#hot" },
  { label: "吃瓜指南", href: "#guide" },
  { label: "关于我们", href: "#about" },
];

export default function GuaNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header id="top" className="sticky top-0 z-50 w-full">
      {/* utility strip */}
      <div className="w-full bg-primary-600 text-background-50">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-1.5 text-[11px] md:px-6 md:text-xs">
          <p className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-flashlight-fill text-xs" aria-hidden="true" />
            <span>理性吃瓜 · 求锤得锤 · 不造谣不传谣</span>
          </p>
          <p className="hidden items-center gap-4 text-background-100 sm:flex">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-2-line" aria-hidden="true" />每日大瓜 · 天天在线
            </span>
            <a href="#guide" className="hover:text-white hover:underline" rel="nofollow">
              投稿与信源
            </a>
          </p>
        </div>
      </div>

      {/* masthead + nav */}
      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/95 backdrop-blur"
            : "border-transparent bg-background-50"
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6">
          {/* brand */}
          <a href="#top" className="group flex items-center gap-3">
            <span className="relative flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <span className="font-heading text-xl font-black tracking-tight">瓜</span>
              <span className="absolute -right-1 -top-1 h-3 w-3 rounded-full bg-accent-400 ring-2 ring-background-50" />
            </span>
            <span className="flex flex-col">
              <span className="flex items-center gap-2">
                <span className="font-heading text-2xl font-black tracking-tight md:text-[26px]">
                  每日大瓜
                </span>
                <span className="hidden rounded-full bg-accent-100 px-2 py-0.5 text-[10px] font-medium text-accent-700 lg:inline-flex">
                  Melon Daily
                </span>
              </span>
              <span className="text-[11px] tracking-widest text-foreground-500">
                吃瓜情报站 · 想听点不一样的
              </span>
            </span>
          </a>

          {/* desktop nav */}
          <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="group relative whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {l.label}
                <span className="absolute inset-x-3 bottom-0.5 h-0.5 origin-left scale-x-0 rounded-full bg-primary-500 transition-transform duration-200 group-hover:scale-x-100" />
              </a>
            ))}
            <a
              href="#about"
              className="ml-2 whitespace-nowrap rounded-lg bg-secondary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
            >
              我要投稿
            </a>
          </nav>

          {/* mobile toggle */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 hover:bg-background-100 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} aria-hidden="true" />
          </button>
        </div>

        {/* mobile panel */}
        {open && (
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 pb-4 md:px-6 lg:hidden">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#about"
              onClick={() => setOpen(false)}
              className="mt-1 whitespace-nowrap rounded-lg bg-secondary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              我要投稿
            </a>
          </div>
        )}
      </div>
    </header>
  );
}